import React from 'react';
import DisableRecacheCard from '../disableRecacheCard/disableRecacheCard';
import ForceHTTPSCard from '../forceHTTPSCard/ForceHTTPSCard';
import ImageLoadingCard from '../imageLoadingCard/imageLoadingCard';
import RenderingDevicesCard from '../renderingDevicesCard/renderingDevicesCard';
import RenderingLocationsCard from '../renderingLocationsCard/renderingLocationsCard';
import RenderTimeoutCard from '../renderTimeoutCard/renderTimeoutCard';

const GeneralSettings = () => {
  return (
    <div className="row">
      <RenderingLocationsCard />
      <DisableRecacheCard />
      <RenderingDevicesCard />
      <RenderTimeoutCard />
      <ImageLoadingCard />
      <ForceHTTPSCard />
    </div>
  );
};

export default GeneralSettings;
